import type { ReactNode } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '@/features/auth/session';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * The one protected-route mechanism (ADR-026, Decision F1). While the
 * session is still being restored from `sessionStorage`, renders a
 * loading state rather than redirecting - redirecting before restoration
 * finishes would bounce an already-logged-in user back to /login on every
 * page reload.
 */
export function ProtectedRoute(): ReactNode {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center" role="status">
        <Skeleton className="h-8 w-32" />
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
